import PropTypes from 'prop-types';

export const filterType = PropTypes.shape({
  activeFilters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    }),
  ),
  clear: PropTypes.func,
  setValue: PropTypes.func,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      values: PropTypes.arrayOf({
        label: PropTypes.string,
        value: PropTypes.oneOf([PropTypes.bool, PropTypes.string]),
      }),
    }),
  ),
});
